<article
  class="bg-surface border-weak flex flex-col gap-2 rounded-md border px-3 py-2.5"
  [attr.aria-label]="'assistant.runs.title' | translate: { plan_id: shortPlan() }">
  <div class="flex flex-wrap items-baseline gap-2 text-xs">
    <app-optimization-job-status [status]="status()" />
    <h4 class="text-text-primary min-w-0 flex-1 text-xs font-semibold">
      {{ 'assistant.runs.title' | translate: { plan_id: shortPlan() } }}
    </h4>
  </div>
  @if (stale()) {
    <p class="text-text-secondary text-xs">
      {{ 'assistant.runs.stale' | translate: { time: staleSince() } }}
    </p>
  }
  <div class="text-2xs flex flex-wrap gap-1">
    @if (elapsed(); as duration) {
      <span class="border-default inline-flex overflow-hidden rounded-xs border">
        <span class="bg-page text-text-secondary px-1.5">{{
          (finished() ? 'assistant.runs.took' : 'assistant.runs.elapsed') | translate
        }}</span>
        <span
          class="text-text-primary px-1.5 font-mono tabular-nums"
          data-testid="run-elapsed"
          >{{ duration }}</span
        >
      </span>
    }
    @if (parameterId(); as parameter) {
      <span class="border-default inline-flex overflow-hidden rounded-xs border">
        <span class="bg-page text-text-secondary px-1.5">{{
          'assistant.runs.parameter' | translate
        }}</span>
        <span class="text-text-primary px-1.5 font-mono" data-testid="run-parameter">{{
          parameter
        }}</span>
      </span>
    }
    @if (state()?.outputPlanId; as out) {
      <span class="border-default inline-flex overflow-hidden rounded-xs border">
        <span class="bg-page text-text-secondary px-1.5">{{
          'assistant.runs.output_plan' | translate
        }}</span>
        <span class="text-text-primary px-1.5 font-mono">{{ out.slice(0, 8) }}…</span>
      </span>
    }
  </div>
  <div class="flex flex-wrap items-center gap-2">
    @if (status() === JobStatusV4.OPTIMIZATION_FINISHED) {
      <button
        type="button"
        data-testid="run-analyse"
        class="btn btn-primary"
        [disabled]="!assistant.canSend() || !state()?.outputPlanId"
        (click)="analyse()">
        {{ 'assistant.runs.analyse' | translate }}
      </button>
      @if (planLink(state()?.outputPlanId); as link) {
        <a class="btn btn-cancel" [href]="link"
          ><i [class]="ICONS.arrowSquareOut"></i
          >{{ 'assistant.runs.open_result' | translate }}</a
        >
      }
    } @else if (failed()) {
      <button
        type="button"
        data-testid="run-ask-why"
        class="btn btn-cancel"
        [disabled]="!assistant.canSend()"
        (click)="askWhy()">
        {{ 'assistant.runs.ask_why' | translate }}
      </button>
    }
    <span class="flex-1"></span>
    @if (planLink(run().planId); as link) {
      <a class="text-accent-main text-xs font-medium hover:underline" [href]="link">{{
        'assistant.runs.view_in_table' | translate
      }}</a>
    }
  </div>
</article>
